export default __webpack_public_path__ + "static/media/5.c621d9d0.jpg";